import { Box, Typography } from "@mui/material";
import useContentProtection from "../Common/useContentProtection";
import { useEffect, useState } from "react";
import { PrivacyPolicyAction } from "./APIs/action";


const Privacy = ({ inModal = false }) => {
  const { onContextMenu, protectionSx } = useContentProtection();
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);
  const policyContent = policy?.content || {};
  const introduction = policyContent?.introduction || policy?.introduction || [];
  const sections = policyContent?.sections || policy?.sections || [];
  useEffect(() => {
      const getPrivacyPolicy = async () => {
          setLoading(true);
          const data = await PrivacyPolicyAction();
          setPolicy(data);
          setLoading(false);
      };
      getPrivacyPolicy();
    }, []);
  if (!policy) return null;

  return (
    <Box
      onContextMenu={onContextMenu}
      sx={{ p: 2, display: "flex", gap: 2, flexDirection: "column", ...protectionSx }}
    >
      {!inModal && <Typography variant="h1">{policy?.title}</Typography>}
      
      {Array.isArray(introduction) &&
        introduction.map((para, idx) => (
          <Typography variant="body1" key={`intro-${idx}`}>
            {para}
          </Typography>
        ))}

      {Array.isArray(sections) &&
        sections.map((section) => (
          <Box key={section.section_id} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="h2">{`${section.section_id}. ${section.title}`}</Typography>

            {Array.isArray(section.subsections) && (() => {
              const textSubsections = section.subsections.filter((subsection) => {
                const subsectionValue = subsection?.text ?? subsection?.content;
                return typeof subsectionValue === "string";
              });

              const objectSubsections = section.subsections.filter((subsection) => {
                const subsectionValue = subsection?.text ?? subsection?.content;
                return typeof subsectionValue !== "string";
              });

              return (
                <>
                  {textSubsections.length > 0 && (
                    <Box sx={{ m: 0, pl: 0, display: "flex", flexDirection: "column", gap: 1 }}>
                      {textSubsections.map((subsection) => {
                        const subsectionValue = subsection?.text ?? subsection?.content;
                        return (
                          <Box key={subsection.id} sx={{ display: "flex", gap: 1 }}>
                            <Typography variant="body1" sx={{ minWidth: "fit-content", fontWeight: 500 }}>{subsection.id}</Typography>
                            <Typography variant="body1">{subsectionValue}</Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  )}

                  {objectSubsections.map((subsection) => {
                    const subsectionValue = subsection?.text ?? subsection?.content;
                    return (
                      <Box key={subsection.id} sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Typography variant="body1" sx={{ minWidth: "fit-content", fontWeight: 500,}}>
                            {subsection.id}
                          </Typography>
                          {subsectionValue?.label && <Typography variant="body1">{subsectionValue.label}</Typography>}
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", pl: 5  }}>
                          <Typography variant="body1">{`Name: ${subsectionValue?.name || ""}`}</Typography>
                          <Typography variant="body1">{`Address: ${subsectionValue?.address || ""}`}</Typography>
                          <Typography variant="body1">{`Email: ${subsectionValue?.email || ""}`}</Typography>
                          <Typography variant="body1">{`Phone: ${subsectionValue?.phone || ""}`}</Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </>
              );
            })()}
          </Box>
        ))}
    </Box>
  );
};

export default Privacy;